import React from 'react'
import { Droppable } from 'react-beautiful-dnd'
import styled from 'styled-components'
import Issue from './Issue'

import {
  maxColWidth,
  gutterSize,
  lightGray,
  textColor,
  gray,
  leftBackgroundColor,
  rightBackgroundColor,
} from '../variables'

// no margin collapse on flex items, hence why the margin is half the gutter size
const Container = styled.div`
  align-self: flex-start;
  background-color: ${props => (props.isLeft ? `${leftBackgroundColor}` : `${rightBackgroundColor}`)};
  border: 1px solid ${gray};
  border-radius: 2px;
  box-shadow: 1px 1px 3px ${lightGray};
  flex: 1 1 400px;
  margin: 0 ${gutterSize / 2}px;
  max-width: ${maxColWidth}px;
  max-height: calc(100vh - 200px);
  overflow-y: scroll;

  :first-of-type {
    margin-left: 0;
  }
`

// use subtler lightGray for border-bottom
const Title = styled.h2`
  border-bottom: 1px solid ${lightGray};
  color: ${textColor};
  padding-bottom: 5px;
  margin: 15px 10px 0;
`

const IssueList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100px;
  padding: 0 10px;
  ${props => props.isDragginOver && 'padding-bottom: 50px;'}
`

function Column(props) {
  const isLeft = props.position === 'left'
  let isFocused = false
  return (
    <Container isLeft={isLeft}>
      <Title>{props.title}</Title>
      <Droppable droppableId={props.id}>
        {(provided, snapshot) => (
          <IssueList
            ref={provided.innerRef}
            {...provided.droppableProps}
            title={props.title}
            isDragginOver={snapshot.isDraggingOver}
          >
            {props.issues.map((issue, index) => {
              isFocused = !!(props.info && props.info.issueId === issue)
              return (
                <Issue
                  isFocused={isFocused}
                  key={issue}
                  issue={issue}
                  index={index}
                  allIssues={props.allIssues}
                  isUnrankedList={isLeft}
                  handleIssueClick={props.handleIssueClick}
                  handleButtonClick={props.handleButtonClick}
                />
              )
            })}
            {provided.placeholder}
          </IssueList>
        )}
      </Droppable>
    </Container>
  )
}

export default Column
